import { EntityRelatedEntitiesGridItem } from './EntityRelatedEntitiesGridItem';
import { EntityTable } from '@backstage/plugin-catalog-react';
import { EntityGridItemProps } from './EntityGridItemProps';
import { RELATION_DISTRIBUTES } from '@appfolio/backstage-plugin-catalog-common';

export const DistributesComponentsGridItem = (props: EntityGridItemProps) => {
  return (
    <EntityRelatedEntitiesGridItem
      {...props}
      relationFilter={{
        type: RELATION_DISTRIBUTES,
        kind: 'Component',
      }}
      title={props.title ?? 'Distributes components'}
      orderedBy={['spec.type', 'metadata.name']}
      columns={[
        EntityTable.columns.createEntityRefColumn({ defaultKind: 'component' }),
        EntityTable.columns.createOwnerColumn(),
        EntityTable.columns.createSpecTypeColumn(),
        EntityTable.columns.createSpecLifecycleColumn(),
      ]}
      lgColumns={[
        EntityTable.columns.createEntityRefColumn({ defaultKind: 'component' }),
        EntityTable.columns.createOwnerColumn(),
        EntityTable.columns.createSpecTypeColumn(),
        EntityTable.columns.createSpecLifecycleColumn(),
        EntityTable.columns.createMetadataDescriptionColumn(),
      ]}
    />
  );
};
